// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'contains', {
  value: function (value) {
    return this.map(i => typeof value === 'string' && value.includes(i))
      .reduce((p, c) => p || c);
  }
});
